import type { Video } from '@/services/videos/types'
import type { Folder } from '@/services/folder/types'
import { Category, Orientation } from '@/interfaces'
export interface PackageBase {
  package_id?: number
  organization_id?: number
  package_name?: string
  video_ids?: string[]
  folder_ids?: number[]
  total_videos?: number
  total_folders?: number
  publishers_count?: number
  decline_count?: number
  description?: string
  tags?: string[]
  created_at?: string
  content_owner_profile_image?: string
  content_owner_name?: string
  cover_image: string
  other_cover_images_paths?: string[] | null
  orientations?: Orientation[]
}

export interface PostPackagePayload {
  package_name: string
  description?: string
  video_ids: string[]
  folder_ids: number[]
  cover_image: string
  other_cover_images_paths: string[] | null
  tags: string[]
}

export interface PutPackagePayload extends PostPackagePayload {
  package_id: string
}

export interface ContentPackage extends PackageBase {
  videos?: Video[]
  folders?: Folder[]
}

export interface Package extends PackageBase {
  first_videos?: Video[]
  first_folders?: Folder[]
}

export interface PackageFilters {
  package_id?: number
  package_name?: string
  search?: string
  sort_by?: string
  sort_order?: string
  results_per_page?: number
  video_ids?: string[]
  folder_ids?: number[]
  page_number?: number
  total_packages?: number
}

export interface PackageProposal {
  id?: number
  package_id?: number
  recipients?: string[]
  all_publishers?: boolean
  results_per_page?: number
  page_number?: number
  sort_order?: string
  sort_by?: string
}

export interface PackageProposals {
  package: PackageBase
  proposal: Proposal
  total_videos: number
  videos: Video[]
}

export interface Packages {
  packages: Package[]
  total_pacakges: number
  results_per_page: number
  total: number
}

export interface Proposal {
  id: string
  package_name: string
  content_owner_org_id: number
  content_owner_name: string
  content_owner_profile_image: string // Organization profile image
  icon_image: string // Channels profile image
  created_at: string
  number_of_videos: number
  status: offeredPackageStatus
  cover_image: string
  orientations?: Orientation[]
  categories?: Category[]
}

export interface PackagesProposalsResponse {
  proposals: Proposal[]
  total_pending: number
  total_pending_per_page: number
  total: number
}

export interface PackagesProposals extends PackagesProposalsResponse {
  total_pending_per_page: number
}

export interface PackageCoverUploadResponse {
  cover_image: string
}

export enum offeredPackageStatus {
  Pending = 'pending',
  Active = 'active'
}

export enum PackageCoverOptions {
  Travel = 'travel',
  Business = 'business',
  Home = 'home',
  Law = 'law',
  Computers = 'computers',
  Culture = 'culture',
  Navigation = 'navigation',
  Health = 'health',
  Shopping = 'shopping',
  Relationships = 'relationships',
  Uploaded = 'uploaded',
  Default = 'default'
}

export interface SelectedCoverImage {
  image: string
  type: PackageCoverOptions
}

export interface AcceptAllProposalsPayload {
  proposal_ids?: string[]
  accept_proposals?: boolean
}
